import * as yup from 'yup';

export const modalAddPortfolioSchema = yup.object().shape({
  title: yup
    .string()
    .required('O título é obrigatório.')
    .max(255, 'Máximo de 255 caracteres')
    .matches(/[a-zA-Z]/, 'O título deve conter pelo menos uma letra.'),
  description: yup
    .string()
    .required('A descrição é obrigatória.')
    .max(1024, 'Máximo de 1024 caracteres'),
  pinned: yup.boolean(),
});
